import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import Preloader from '../Preloader/Preloader';

class CustomDropdown extends Component {

  static propTypes = {
    categories: PropTypes.array.isRequired,
    selected: PropTypes.any.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      listOpened: false,
      categories: [],
      selected: this.props.selected,
      placeholder: this.props.placeholder,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      ...nextProps,
    });
  };

  selectItem = (item) => {
    this.setState(
      {
        selected: item,
        listOpened: false,
      },
      this.props.onChange(item),
    );
  };

  handleKeyboardPick = (e, item) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      this.selectItem(item);
    }
  };

  toggleList = () => {
    this.setState(prevState => ({
      listOpened: !prevState.listOpened,
    }));
  };

  handleClickOutside(e) {
    this.setState({
      listOpened: false,
    });
  }

  render() {
    const { className } = this.props;
    const {
      listOpened, categories, selected, placeholder,
    } = this.state;
    return (
      <div
        className={classNames('custom-dropdown', 'custom-dropdown--halfwide', className, {
          active: listOpened,
        })}
      >
        <div className="custom-dropdown__selected" onClick={this.toggleList}>
          <div className="custom-dropdown__selected-wrapper">
            {selected.title || placeholder}
          </div>
        </div>
        <ul className="custom-dropdown__list">
          {categories.length ? (
            categories.map(item => (
              <li
                className="custom-dropdown__item"
                key={item.id}
                tabIndex="0"
                onClick={() => this.selectItem(item)}
                onKeyDown={e => this.handleKeyboardPick(e, item)}
              >
                {item.title}
              </li>
            ))
          ) : (
            <li>
            <Preloader />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default onClickOutside(CustomDropdown);
